{
  "statement": "CARii is one account for the everyday things students actually need — starting with a car you can book in under a minute."
}
